import TripChangeTicket from './trip-change-ticket-component';
import TripChangeTicketValidator from './trip-change-ticket-validator';
import TripChangeTicketService from './trip-change-ticket-service';

import './trip-change-ticket-modal.scss';

const MODULE_NAME = 'app.trip.change-ticket';
const module = angular.module(MODULE_NAME, [])
    .directive(TripChangeTicket.DIRECTIVE_NAME, TripChangeTicket)
    .directive(TripChangeTicketValidator.DIRECTIVE_NAME, TripChangeTicketValidator)
    .service('tripChangeTicketService', TripChangeTicketService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-change-ticket/trip-change-ticket-module.js